var _path, _path2, _path3, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPinYellowPoi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M20,1.823"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M20.012,0.285h-0.023c-7.554,0-13.701,6.147-13.701,13.701c0,7.148,3.93,12.01,7.397,16.296l0.312,0.385 c1.256,1.552,2.682,3.312,3.271,4.439c0.608,1.166,0.832,2.168,0.845,2.224l0.039,0.116c0.213,0.847,0.968,1.449,1.839,1.449 c0.805,0,1.513-0.505,1.789-1.264c0.035-0.077,0.082-0.189,0.121-0.349c0.002-0.009,0.227-1.011,0.836-2.177 c0.588-1.128,2.012-2.888,3.268-4.439l0.314-0.385c3.467-4.286,7.396-9.147,7.396-16.296C33.713,6.432,27.568,0.285,20.012,0.285z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 20,
    cy: 14.1641,
    r: 24.7979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A91F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M20.011,1.872h-0.022c-6.78,0-12.296,5.516-12.296,12.296c0,6.578,3.69,11.138,6.945,15.165 c1.324,1.637,2.907,3.556,3.571,4.828c0.664,1.271,0.896,2.349,0.896,2.349c0.005,0.021,0.019,0.043,0.027,0.065 c0.075,0.413,0.422,0.732,0.857,0.732c0.398,0,0.724-0.264,0.835-0.625c0.028-0.056,0.056-0.112,0.071-0.173 c0,0,0.231-1.077,0.893-2.349c0.666-1.272,2.248-3.191,3.572-4.828c3.258-4.026,6.945-8.587,6.945-15.165 C32.307,7.388,26.789,1.872,20.011,1.872z M20.01,18.583c-2.619,0-4.742-2.122-4.742-4.742c0-2.618,2.123-4.741,4.742-4.741 c2.619,0,4.74,2.123,4.74,4.741C24.75,16.461,22.629,18.583,20.01,18.583z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 187.126,
    cy: 28.9229,
    r: 2.4375,
    gradientTransform: "matrix(0.791 0 0 1.5854 -127.9702 -8.3174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_2_)",
    cx: 20.001,
    cy: 36.549,
    rx: 6.294,
    ry: 4.201
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinYellowPoi);
export default __webpack_public_path__ + "static/media/icon-pin-yellow-poi.e7d9ee52.svg";
export { ForwardRef as ReactComponent };